export default {
    methods: {
        //COMPONENTS
        registerComponent(component) {
            if (component.dataProvider == this.id) {
                this.l_components.push(component);
            }
        },
        getComponents() {
            return this.l_components;
        }
    }
}
